import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from 'components/utils/colors'

import Badge from 'components/Shared/Badge/Index'
import Icon from 'components/Shared/Icon/Index'

const StyledBadge = styled(Badge)`
  margin-left: 4px;
  padding: 0 5px;
`

const FilterBadge = ({ isGlobal, isPublished, tooltipText, tooltipId }) => {
  let iconName, badgeColor
  if (isGlobal) {
    iconName = isPublished ? 'icon-multi-user-12' : 'icon-admin-12'
    badgeColor = isPublished ? colors.globalGray : colors.infoGray
  } else {
    iconName = 'icon-user-12'
    badgeColor = colors.pausedGray
  }

  return (
    <StyledBadge
      margin='0'
      color={badgeColor}
      data-tooltip-content={tooltipText}
      data-tooltip-id={tooltipId}
    >
      <Icon iconName={iconName} color={colors.secondary40} />
    </StyledBadge>
  )
}

FilterBadge.propTypes = {
  isGlobal: PropTypes.bool,
  isPublished: PropTypes.bool,
  tooltipText: PropTypes.string,
  tooltipId: PropTypes.string,
}

export default FilterBadge
